import(/* webpackMode: "eager" */ "/app/apps/explore/app/@sidebar/layout.tsx");
